const truncateStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  padding: '4px 2px'
};

export const tableColumns = [
  {
    name: 'Feedback ID',
    selector: row => row.feedback_id,
    sortable: true,
    center: true,
    width: '200px',
    style: truncateStyle,
  },
  {
    name: 'Name',
    selector: row => row.user_name,
    sortable: true,
    center: true,
    width: '200px',
    style: truncateStyle,
  },
  {
    name: 'Feedback',
    selector: row => row.description,
    sortable: true,
    center: true,
    width: '350px',
    style: truncateStyle,
    cell: row => (
      <div style={{ 
        ...truncateStyle,
        color: '#5C61F2',
        width: '100%',
        textAlign: 'center',
        maxWidth: '300px',
        fontWeight: 'bold',
      }}>
        {row.description.length > 50 ? `${row.description.substring(0, 50)}...` : row.description}
      </div>
    ),
  },
  {
    name: 'Issue Date',
    selector: row => row.created_on_formatted,
    sortable: true,
    center: true,
    width: '200px',
    style: truncateStyle,
  },
  {
    name: 'Action',
    selector: row => row.action,
    sortable: false,
    center: true,
    width: '200px',
    id: 'action',
    style: truncateStyle,
  }
];